import CardPin from 'components/CardPin'
import { useEffect, useState } from 'react'

export const SetPinModal = ({
  isOpen,
  onHandleSetPin,
  isLoading,
  onPressBack,
}) => {
  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        const firstInput = document.getElementById('form-control-0')
        if (firstInput) {
          firstInput.focus()
        }
      }, 100)
    }
  }, [isOpen])

  return isOpen ? (
    <div
      data-testid="set-pin-modal"
      style={{
        zIndex: 9999,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: 'white',
      }}
    >
      <CardPin
        title={'Buat PIN Anda'}
        testIdPrefix="set-pin"
        length={6}
        loading={isLoading}
        optionToShowPin={true}
        withButton={true}
        handleSubmit={(pin) => onHandleSetPin(pin)}
        onPressBack={onPressBack}
        isBack={false}
      />
    </div>
  ) : null
}
